import {
  IBaseArrayResultDto,
  parseBlockedAccountPayload,
} from '@skillarea/lib-shared';

import { accountBlockedStore } from '~/stores/accountBlockedStore';
import { onboardStore } from '~/stores/onboardStore';

export const unauthorizedInterceptor = (response: IBaseArrayResultDto) => {
  if (typeof window === 'undefined') return false;

  const blockedAccount = parseBlockedAccountPayload(response);
  if (response.status === 403 && blockedAccount) {
    accountBlockedStore.getState().show(blockedAccount, {
      clearClientSession: true,
    });
    return true;
  }

  if (
    response.status === 403 &&
    !import.meta.env.VITE_DEV_IS_401_LOGOUT_DISABLED
  ) {
    onboardStore.getState().signOut();
    return true;
  }
  if (response.status === 401) {
    if (typeof window !== 'undefined') {
      globalThis.window.location.href = '/';
    }
  }

  return false;
};
